import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const WorkkardDetailSec2Loader = props => {
        return(<>
      {props.count && props.count > 0 && (
                    Array.from({ length: props.count }, (_, i) => (
                        <ContentLoader 
                        rtl
                        height={40}
                        width={340}
                        speed={2}
                        key={i+1}
                    >
                        <rect x="4.84" y="1.67" rx="8" ry="8" width="100" height="12" /> 
                        <rect x="3.84" y="18.67" rx="8" ry="8" width="153" height="12" /> 
                        <rect x="178.84" y="2.67" rx="8" ry="8" width="100" height="12" /> 
                        <rect x="177.84" y="16.67" rx="8" ry="8" width="153" height="12" />
                    </ContentLoader>
                    ))
                )}</>)
    }